// src/components/ValueProps/ValueProps.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./About.module.css";

export default function About() {
  const { t } = useTranslation("home");

  return (
    <section className={styles.root} aria-labelledby="valueprops-title">
      <div className={styles.overlapShadow} aria-hidden />
      <div className={styles.container}>
        <section className={styles.infoBox}>
          <div className={styles.text}>
            <h2>{t("about_title")}</h2>
            <p>{t("service_desc1")}</p>
            <p>{t("service_desc2")}</p>
            <p>{t("service_desc3")}</p>
            {/* <div>
            <img src={imagePro} alt="App preview" className={styles.mock} />
          </div> */}
          </div>
        </section>
      </div>
    </section>
  );
}
